<section class="runs" aria-labelledby="runs-title">
  <ng-container *ngIf="{ all: runs | async, deltas: pnlDeltas | async, failed: loadFailed | async, base: baseCases | async, before: mtiBefore | async } as v">
    <header class="runs-head">
      <div>
        <h1 id="runs-title" class="runs-title">Runs</h1>
        <p class="runs-meta">
          <ng-container *ngIf="v.all">{{ v.all.length | number }} runs, newest first</ng-container>
        </p>
      </div>
      <div class="runs-search" role="search">
        <mat-icon class="runs-search-icon" aria-hidden="true">search</mat-icon>
        <input type="search" class="runs-search-input" placeholder="Search by run name or who started it"
          aria-label="Search runs by name or who started it" [ngModel]="term" (ngModelChange)="search($event)" autocomplete="off">
        <button *ngIf="term" type="button" class="runs-search-clear" (click)="search('')" aria-label="Clear search">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </div>
    </header>

    <!-- The run the desk opens this page for: the latest base case, against the one before. -->
    <section *ngIf="v.base as base" class="base-case" aria-label="Latest timestamp">
      <div class="base-case-what">
        <span class="base-case-label">Latest timestamp</span>
        <span class="base-case-name">{{ base.current.name }}</span>
        <span class="base-case-when">{{ base.current.runHistories[0].eventTime | date: 'EEE d MMM, HH:mm' }}</span>
      </div>
      <div class="base-case-pnl">
        <pnl [monetaryValue]="base.current.optimisationResult?.pnL" [suffix]="true"></pnl>
        <span *ngIf="baseCaseMove(base) as move" class="base-case-move" [class.up]="move > 0" [class.down]="move < 0">
          {{ move >= 0 ? '+$' : '−$' }}{{ (move >= 0 ? move : -move) | number: '1.2-2' }}M vs {{ base.prior?.name }}
        </span>
      </div>
      <div class="base-case-go">
        <a class="go-btn" [routerLink]="['/pnl-explain']"
          [queryParams]="base.prior ? { current: base.current.runId, prior: base.prior.runId } : { current: base.current.runId }">
          <mat-icon aria-hidden="true">query_stats</mat-icon>P&amp;L Explain
        </a>
        <a class="go-btn" [routerLink]="['/mti-comparison']" [queryParams]="mtiQuery(base.current, v.before)">
          <mat-icon aria-hidden="true">compare_arrows</mat-icon>MTI Compare
        </a>
        <a class="go-btn" [routerLink]="['/gantt']" [queryParams]="{ run: base.current.runId }">
          <mat-icon aria-hidden="true">view_timeline</mat-icon>Gantt
        </a>
      </div>
    </section>

    <div class="runs-filters">
      <div class="chip-group" role="group" aria-label="Status">
        <span class="chip-label">Status</span>
        <button type="button" class="chip" [class.on]="!statuses.size" [attr.aria-pressed]="!statuses.size"
          (click)="statuses.clear(); resetPaging()">All</button>
        <button *ngFor="let c of statusChips" type="button" class="chip" [class.on]="statuses.has(c[0])"
          [attr.aria-pressed]="statuses.has(c[0])" (click)="toggleStatus(c[0])">{{ c[1] }}</button>
      </div>
      <div class="chip-group" role="group" aria-label="Source">
        <span class="chip-label">Source</span>
        <button *ngFor="let c of sourceChips" type="button" class="chip" [class.on]="sources.has(c[0])"
          [attr.aria-pressed]="sources.has(c[0])" (click)="toggleSource(c[0])">{{ c[1] }}</button>
      </div>
      <button *ngIf="filtering" type="button" class="runs-clear" (click)="clearFilters()">Clear filters</button>
    </div>

    <div *ngIf="v.all || v.failed; else loading" class="runs-list">
      <div class="runs-cols" aria-hidden="true">
        <span></span><span>Run</span><span>Initiated by</span><span>Last update</span><span class="center">Status</span><span class="right">P&amp;L</span><span></span>
      </div>
      <ng-container *ngIf="v.all; else failed">
        <ng-container *ngIf="visible(v.all) as filtered">
          <ng-container *ngFor="let run of filtered.slice(0, shown); let i = index; trackBy: trackRun">
            <h2 *ngIf="i === 0 || dayOf(run) !== dayOf(filtered[i - 1])" class="runs-day">{{ dayLabel(run) }}</h2>
            <run-card [run]="run" [pnlDeltaInfo]="v.deltas?.get(run.runId)" [mtiQuery]="mtiQuery(run, v.before)"
              [expanded]="expandedRunId === run.runId" (toggle)="onToggle($event)"></run-card>
          </ng-container>

          <div *ngIf="!filtered.length" class="runs-empty">
            <p>No runs match{{ term ? ' "' + term + '"' : '' }} with these filters.</p>
            <button type="button" class="runs-more-btn" (click)="clearFilters()">Clear filters</button>
          </div>
          <div *ngIf="filtered.length > shown" class="runs-more">
            <span>Showing {{ shown | number }} of {{ filtered.length | number }}</span>
            <button type="button" class="runs-more-btn" (click)="shown = shown + pageSize">Show {{ pageSize }} more</button>
          </div>
          <p *ngIf="filtered.length && filtered.length <= shown && filtering" class="runs-count">
            {{ filtered.length | number }} {{ filtered.length === 1 ? 'run matches' : 'runs match' }}
          </p>
        </ng-container>
      </ng-container>
      <ng-template #failed>
        <div class="runs-empty" role="alert">
          <p>Couldn't load the runs.</p>
          <button type="button" class="runs-more-btn" (click)="retry()">Try again</button>
        </div>
      </ng-template>
    </div>
    <ng-template #loading>
      <div class="runs-loading" role="status"><spinner [size]="1.25"></spinner>Loading runs…</div>
    </ng-template>
  </ng-container>
</section>
